<template>
    <div class="contact-us">
        <div class="contact-us-banner">
            <div class="contact-us-banner-img-cover">
            </div>
            <div class="contact-us-banner-title">
                Contact Us
            </div>
            <div class="contact-us-banner-suggestion-and-question">
                Have any suggestion or question? Or found a mistake?
            </div>
            <div class="contact-us-banner-description">
                You may contact us via email on
                <span class="keyword">
                    admin@atalearninghub.com
                </span>
                or telephone
                <i class="fa fa-whatsapp" aria-hidden="true">
                </i>
                <span class="keyword">
                    (+65)88133694
                </span>
            </div>
            <div class="contact-us-banner-description office">
                Our Office:<br>
                221 Henderson Road <br>
                #08-18 Henderson Building Singapore 159557 Room 801.
            </div>
        </div>
        <div class="contact-us-content">
            <div class="contact-us-content-logo">
                <img class="contact-us-content-logo-pc" src="../assets/img/ata-line.png">
                <img class="contact-us-content-logo-mobile" src="../assets/img/mobile/ata-line.png">
            </div>
            <div class="contact-us-content-title">
                Get In Touch With Us
            </div>
            <div class="contact-us-content-form"  @change="checkValid()">
                <div class="contact-us-content-form-title">
                    Full Name
                </div>
                <div class="contact-us-content-form-column">
                    <el-input v-model="form.name" placeholder="Full Name"/>
                </div>
                <div class="contact-us-content-form-title">
                    Email Address
                </div>
                <div class="contact-us-content-form-column">
                    <el-input v-model="form.email" placeholder="Email Address"/>
                </div>
                <div class="contact-us-content-form-title">
                    Your Message
                </div>
                <div class="contact-us-content-form-column">
                    <textarea v-model="form.msg" placeholder="Your Message"/>
                </div>
                <div class="contact-us-content-form-submit" :class="{'valid': isActive}">
                    <el-button @click="send()" v-loading="isButtonLoading">
                        Send Message
                    </el-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'ContactUs',
        data() {
            return {
                form: {
                    name: '',
                    email: '',
                    msg: '',
                },
                isButtonLoading: false,
                isActive: false,
            }
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {

            },
            checkValid() {
                var valid = true;

                for (var key in this.form) {
                   if (!this.form[key]) {
                        valid = false;
                   }
                }

                valid ? this.isActive = true : this.isActive = false;
            },
            send() {
                this.isButtonLoading = true;

                this.$api.request('System/contactUs', this.form).then((result) => {

                    if (result.status == true) {
                        this.$message.success('Sent successfully');
                        this.isButtonLoading = false;
                        this.resetForm();
                    } else {
                        this.isButtonLoading = false;
                        this.$message.error(result.msg);
                    }
                }).catch(error => {
                    this.isButtonLoading = false;
                    this.$message.error(error.msg);
                });
            },
            resetForm() {
                this.form.name = '';
                this.form.email = '';
                this.form.msg = '';
            },
        }
    }
</script>
<style lang='scss' type='text/css'>
    @import "../styles/pc/ContactUs.scss";
    @import "../styles/mobile/ContactUs.scss";
</style>
